import type { Locale } from '../context/LocaleContextProvider'

// The calendar date as written in Contentful (`2025-07-02T22:00-04:00` → 2025-07-02). Converting the timestamp
// to a time zone first could move it to the next or previous day.
const DATE_PART = /^(\d{4})-(\d{2})-(\d{2})/

const FORMATS: Record<Locale, { intlLocale: string; options: Intl.DateTimeFormatOptions }> = {
  // `Jul 02, 2025`: the format `date(formatString: "MMM DD, YYYY")` produced before. Formatted as en-US so English
  // dates can't change with a browser's en-CA data.
  'en-CA': { intlLocale: 'en-US', options: { month: 'short', day: '2-digit', year: 'numeric', timeZone: 'UTC' } },
  // `2 juillet 2025`
  'fr-CA': { intlLocale: 'fr-CA', options: { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' } },
}

/**
 * @description formats a raw Contentful blog date for the page locale. Returns '' when there's no date, and the
 * value unchanged if it isn't an ISO date.
 * @example formatBlogDate('2025-07-02T00:00-04:00', 'fr-CA') => '2 juillet 2025'
 */
export const formatBlogDate = (date: string | null | undefined, locale: Locale): string => {
  if (!date) return ''
  const match = DATE_PART.exec(date)
  if (!match) return date
  const [, year, month, day] = match
  const utcDate = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)))
  const { intlLocale, options } = FORMATS[locale]
  return new Intl.DateTimeFormat(intlLocale, options).format(utcDate)
}
